// Hides the "One-Time Purchase" options and selects the Subscription options on the Bundler Landing Page
let subWidgetRenderTimeout;

document.addEventListener('sealsubs:subscription_widget_created', function () {
  console.log("Subscription Widget Created.");
  clearTimeout(subWidgetRenderTimeout);
  subWidgetRenderTimeout = setTimeout(() => {
    activateSubscriptionRadios();
  }, 300);
});


async function activateSubscriptionRadios() {

  //console.log("Activating subscription radios...");
  const isBundlerLandingPage = window.location.pathname.indexOf('/mix-&-match-jerky-subscription-8l9t') !== -1;

  if (!isBundlerLandingPage) return;
  // Hide One-Time Purchase Options
  const oneTimeOptions = document.querySelectorAll('div.sls-purchase-options-container > div:not([data-selling-plan-group])');
  oneTimeOptions.forEach(option => {
    option.style.display = 'none';
  });

  // For each purchase options container (i.e., widget)
  const widgetContainers = document.querySelectorAll('.sls-purchase-options-container');

  for (const widget of widgetContainers) {
    const subRadioContainer = widget.querySelector('div:not(.sls-disabled-option-container)[data-selling-plan-group] > div > div.seal-col.seal-col-radio');
    if (subRadioContainer) {
      try {
        await waitForWidgetReady(subRadioContainer);
        // Find the actual input inside and trigger a real change event
        const radioInput = subRadioContainer.querySelector('input[type="radio"]');
        if (radioInput) {
          radioInput.checked = true;
          radioInput.dispatchEvent(new Event('change', { bubbles: true }));
          //console.log('Activated radio in widget:', widget);
        }
      } catch (err) {
        console.warn("Failed to activate radio:", err);
      }
    }
  }
}

// Waits until the widget and radio input are fully rendered and ready
function waitForWidgetReady(container, timeout = 5000) {
  return new Promise((resolve, reject) => {
    const start = Date.now();
    function check() {
      const radioInput = container.querySelector('input[type="radio"]');
      const ready = container.offsetParent !== null && radioInput && radioInput.offsetParent !== null && !radioInput.disabled;
      if (ready) { resolve(); } else if (Date.now() - start > timeout) { reject(new Error('Widget radio not ready in time')); } else { requestAnimationFrame(check); }
    }
    check();
  });
}
